import React from 'react';
import * as ProductTileGoogleAnalytics from '../../_modules/google_analytics/product/product_tiles';
import { CatalogPromotionsStore } from '../../_flux/stores/catalog_promotions_store';
import { setSkuAction, showAction } from '../../_flux/actions/notify_me_actions';
import { CatalogPromotions } from '../../_flux/components/catalog_promotions_revamp/catalog_promotions_revamp';
import { handleView } from '../handle_view';
import { show } from '../../_flux/actions/friendbuy_light_box_actions';
import { setAction as setProductAction } from '../../_flux/actions/products_actions';
import LightboxActions, { openAction as openCarFittingStationFinder } from '../../_flux/actions/lightbox_actions';
import MapActions from '../../_flux/actions/map_actions';
import { ProductsStore } from '../../_flux/stores/products_store';
import FittingStationFinderConstants from '../../_flux/constants/fitting_station_finder_constants';
import { getMap } from '../../_flux/helper/gmap';
import parseGoogleLatLng from '../../_flux/helper/parse_google_lat_lng';
import FittingStationStore from '../../_flux/stores/fitting_station_store';
import StationsActions from '../../_flux/actions/fitting_station_actions';
import MapStore from '../../_flux/stores/map_store';
import PostcodeStore from '../../_flux/stores/postcode_store';
import { loadStations } from '../../_modules/fitting_station/load_stations';
import { FsfPages } from '../../_constants/fsf_pages';
import openAlternativeProductStockOnClick from '../catalog_items/open_alternative_product_stock_onlick';
import { loadGoogleMapDependencies } from '../../_global/initGoogleMapDependencies';
import ActiveStationsActions from '../../_flux/actions/active_station_actions';

const stores = {
    state: CatalogPromotionsStore,
};

const render = ({ state }, options) => (
    <CatalogPromotions
        promotions={state.promotions}
        onNotifyMeClick={onNotifyMeClick}
        onOpenFSFClick={onOpenFSFClick}
        onClickAddToCart={onClickAddToCart}
        staticImagesUrl={TYROOLA.globals.staticImagesUrl}
        metroArea={options.metroArea}
        showShowDetailsButton={options.showShowDetailsButton}
        onProductClick={onProductClick}
        currencyIsoCode={TYROOLA.globals.currencyIsoCode}
        onSeeHowItWorksClick={e => e.preventDefault() ^ show()}
        productType={options.productType}
        onAlternativeProductStockClick={onAlternativeProductStockClick}
        buyerAssistUrl={state.buyerAssistUrl}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);

const onNotifyMeClick = productSku => {
    setSkuAction(productSku);
    showAction();
    ProductTileGoogleAnalytics.openNotifyWhenRestockedLightbox(productSku);
};

const onAlternativeProductStockClick = (productSku, productBatchStocks) => {
    const { promotions } = CatalogPromotionsStore.getState();
    let product = promotions.find(product => product.sku === productSku);
    openAlternativeProductStockOnClick(product, productBatchStocks);
};

const onClickAddToCart = product => {
    addProductToCart(product);
}

async function addProductToCart(props) {
    await _prepareCartRequest(props);
    window.location = `${location.origin}${TYROOLA.globals.baseUrl}/cart/`;
}

function _prepareCartRequest(props) {
    const wheelAlignmentTwo = props.wheelAlignmentTwo ? 1 : 0;
    const wheelAlignmentFour = props.wheelAlignmentFour ? 1 : 0;
    let qty = 0;
    if (props.stock > 0) {
        if (props.stock < 4) {
            qty = props.stock;
        } else if (props.stock >= 4) {
            qty = 4;
        }
    }

    return ActiveStationsActions.addProductToCartAction(
        { id: '', qty },
        props.sku,
        false,
        true,
        wheelAlignmentTwo,
        wheelAlignmentFour,
    );
}

const onOpenFSFClick = productSku => {
    loadGoogleMapDependencies();
    TYROOLA.mapsInitiated.then(() => {
        LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
        const { promotions } = CatalogPromotionsStore.getState();
        const selectedPromotionIndex = promotions.findIndex(promotion => promotion.sku === productSku);
        let product = promotions[selectedPromotionIndex];
        product.id = product.sku;
        if (product.stock > 0) {
            if (product.stock < 4) {
                product.qty = product.stock;
            } else if (product.stock >= 4) {
                product.qty = 4;
            }
        }

        const { appliedPostcode } = PostcodeStore.getState();
        const latLng = parseGoogleLatLng(MapStore.getState().latLng);
        if (typeof latLng.lat !== 'undefined'
            && typeof latLng.lng !== 'undefined'
            && null !== appliedPostcode) {
            let stations = FittingStationStore.getState().stations;
            if (stations.length > 0) {
                let currentProducts = ProductsStore.getState();
                if (currentProducts.length > 0 && productSku !== currentProducts[0].id) {
                    StationsActions.clearStationAction();
                    setProductAction([product]);
                    loadStations(appliedPostcode);
                }
            } else {
                setProductAction([product]);
                loadStations(appliedPostcode);
            }
            LightboxActions.openAction();
            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
        } else {
            setProductAction([product]);
        }

        openCarFittingStationFinder();
    });
};

const onProductClick = clickedProductSku => {
    const { promotions } = CatalogPromotionsStore.getState();
    const clickedPromotionIndex = promotions.findIndex(promotion => promotion.sku === clickedProductSku);
    const eventLabel = ['Premium', 'Midrange', 'Budget'][clickedPromotionIndex];

    if (eventLabel !== '') {
        ProductTileGoogleAnalytics.clickOnProduct('Catalog Promotion', eventLabel);
    }
};
